/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { ProjectDetailTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const projectDetailResetTimestamp = state => ({
  ...state,
  timestamp: Date.now()
});

export const projectDetailSetResId = (state, { resId }) => ({
  ...state,
  timestamp: Date.now(),
  modelIsLoading: false,
  resId
});

export const projectDetailShowModelLoading = (state, { boolean }) => ({
  ...state,
  modelIsLoading: boolean
});

export const projectDetailShowModelSuccess = (state, { model }) => ({
  ...state,
  model
});

export const projectDetailUpdateModelSuccess = (state, { model }) => ({
  ...state,
  model
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [ProjectDetailTypes.PROJECT_DETAIL_RESET_TIMESTAMP]: projectDetailResetTimestamp,
  [ProjectDetailTypes.PROJECT_DETAIL_SET_RES_ID]: projectDetailSetResId,
  [ProjectDetailTypes.PROJECT_DETAIL_SHOW_MODEL_LOADING]: projectDetailShowModelLoading,
  [ProjectDetailTypes.PROJECT_DETAIL_SHOW_MODEL_SUCCESS]: projectDetailShowModelSuccess,
  [ProjectDetailTypes.PROJECT_DETAIL_UPDATE_MODEL_SUCCESS]: projectDetailUpdateModelSuccess
});
